import script from "./ConectWhatsApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConectWhatsApp.vue?vue&type=script&setup=true&lang=ts"

import "./ConectWhatsApp.vue?vue&type=style&index=0&id=ee7e6970&lang=css"

const __exports__ = script;

export default __exports__